import { createSelector } from '@reduxjs/toolkit';

export const sessionStateSelector = (rootReducer: any) => rootReducer.session;

export const emailDetectedSelector = createSelector(sessionStateSelector, stateProp => stateProp.emailDetected);
export const userLoggedSelector = createSelector(sessionStateSelector, stateProp => stateProp.userLogged);
export const userDummySelector = createSelector(sessionStateSelector, stateProp => stateProp.userDummy);
export const userExistSelector = createSelector(sessionStateSelector, stateProp => stateProp.userExist);
